export const ConnectStatusChangedEventName = 'x_connect_status_changed';
